import React, { useEffect } from "react";
import { InputAdornment, TextField } from "@material-ui/core";
import { resetOnClick } from "helpers/resetOnClick";
import { cleanNumber } from "helpers/cleanNumbers";

export const FormFlowmeterUpdate = ({ values }) => {
  const { flowmeter, handleNumberInputOnChange, handleNewValues } = values;

  useEffect(() => {
    const clean = cleanNumber(flowmeter);
    clean < 0 &&
      handleNewValues({
        flowmeter: 0,
      });
  }, [flowmeter]);
  return (
    <TextField
      label="Actualizar cuenta litros"
      name="flowmeter"
      value={flowmeter}
      variant="outlined"
      onChange={handleNumberInputOnChange}
      fullWidth
      size="small"
      InputProps={{
        endAdornment: <InputAdornment position="end">lts</InputAdornment>,
        inputProps: {
          right: "1",
          style: { textAlign: "center" },
        },
      }}
    />
  );
};
